import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import BurgerMenu from "./components/BurgerMenu";
import LandingHeader from "./components/LandingHeader";
import LandingFooter from "./components/LandingFooter";
import decorationEllipse from "../../assets/landing/top-right-decoration-ellipse.png";
import decorationEllipseMob from "../../assets/landing/ellipse-header-dec-mob.png";
import Lenis from "@studio-freight/lenis";
import { MarketingBanner } from "views/components/PresaleBanner/PresaleBanner";
import { motion } from "framer-motion";
import "./style.css";
import { ToastContainer } from "react-toastify";

const MainLayout = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      wheelMultiplier: 1,
      touchMultiplier: 1.5,
      infinite: false,
      autoResize: true,
    });

    function raf(time: number) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <BurgerMenu handleClose={handleClose} isOpen={isOpen} />
      <section className="w-full box-border bg-[#EDEDF6] min-h-dvh font-luxora-book relative overflow-hidden">
        <MarketingBanner />

        <img
          className="absolute left-0 z-10 pointer-events-none top-0 hidden md:block"
          src={decorationEllipse}
          alt="decoration ellipse"
        />
        <img
          className="absolute left-0 z-10 pointer-events-none top-0 w-full md:hidden"
          src={decorationEllipseMob}
          alt="decoration ellipse"
        />

        <motion.div
          className="lg:min-h-[calc(100vh-58px) pt-4 lg:pt-8 lg:max-h-[calc(100vh-58px)]]"
          initial={{ opacity: 0, y: -75 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.4,
            duration: 0.5,
            ease: "easeOut",
          }}
        >
          <LandingHeader handleOpen={handleOpen} />
        </motion.div>

        <main style={{ scrollSnapType: "y mandatory" }}>
          <Outlet />
        </main>

        <LandingFooter />
      </section>{" "}
      <BurgerMenu handleClose={handleClose} isOpen={isOpen} />
    </>
  );
};

export default MainLayout;
